import variables from './variables'

export default {
  meta: { themeName: 'k5kit' },

  globalNav: {
    background: variables.colors.k5kit4,
    iconHoverBackground: variables.colors.opacity_20,
  },
  colors: {
    buttons: {
      primaryBackground: variables.colors.k5kit3,
      primaryBackgroundHover: variables.colors.k5kit1,
      primaryBackgroundDisabled: variables.colors.buttonDisabledKit,
      secondaryText: variables.colors.k5kit4,
      secondaryOutline: variables.colors.k5kit4,
      tabActive: variables.colors.k5kit2,
      tabDefault: variables.colors.darkGray,
    },
    links: {
      primary: variables.colors.k5kit3,
      primaryHover: variables.colors.k5kit1,
    },
    themeAccent: variables.colors.k5kit5,
    themeHighlight: variables.colors.k5kit2,
    themePrimary: variables.colors.k5kit4,
    themeSecondary: variables.colors.k5kit1,
    heading: {
      level: {
        1: variables.colors.k5kit2,
        2: variables.colors.k5kit2,
        3: variables.colors.k5kit2,
      },
    },
  },
  buttons: {
    borderRadius: '21.5px',
  },
  banners: {
    headerTextColor: variables.colors.black,
    headerTextFont: 'Sharpslab-bold',
    headerTextSize: '36px',
    bannerTextColor: variables.colors.darkGray,
    landingBackgroundColor: variables.colors.transparent,
    alignment: 'flex-start',
    textAlignment: 'left',
    contentTypeDescriptionBackgroundColor: variables.colors.gray500,
    contentTypeDescriptionIconColor: variables.colors.black,
    boxShadow: `0px 3px 0px ${variables.colors.gray600}`,
  },
  callouts: {
    headerTextColor: variables.colors.black,
    headerTextFont: 'Sharpslab-bold',
    bodyTextColor: variables.colors.darkGray,
    backgroundColor: variables.colors.gray500,
    iconBorderRadius: '0.688rem 0.688rem 0.688rem 0.688rem',
    boxShadow: `0px 3px 0px ${variables.colors.gray600}`,
  },
  anchorNavigation: {
    backgroundColor: variables.colors.lighterGray,
    borderBottomStyle: 'dotted',
    borderBottomColor: '#BBBBBB',
    borderBottomWidth: 'thick',
    topPadding: '0.688rem',
    bottomPadding: '0.5rem',
    boxShadow: `none`,
  },
  resources: {
    backgroundColorTop: variables.colors.transparent,
    backgroundColorBottom: variables.colors.transparent,
  },
}
